import { render } from "./slide4.vue?vue&type=template&id=2f6e6179&scoped=true"
import script from "./slide4.vue?vue&type=script&lang=js"
export * from "./slide4.vue?vue&type=script&lang=js"

import "./slide4.vue?vue&type=style&index=0&id=2f6e6179&lang=scss&scoped=true"

import exportComponent from "/Users/dima/Projects/OrangeStatic/rise-homestories/public/themes/rise-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6e6179"]])

export default __exports__